module.exports = require('./augmentFetchPayloadCorsBypass')
